import { render, staticRenderFns } from "./ContractAdd.vue?vue&type=template&id=0a2cbf64&scoped=true"
import script from "./ContractAdd.vue?vue&type=script&lang=js"
export * from "./ContractAdd.vue?vue&type=script&lang=js"
import style0 from "./ContractAdd.vue?vue&type=style&index=0&id=0a2cbf64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2cbf64",
  null
  
)

export default component.exports